import DragDropFile from "../../DragDrop/DragDropFile";
import React from "react";
import FileUploadContainer from "./FileUploadContainer";

const DragAndUploadFile = (props: any) => {
  const { setFile, handleDrop, errored, importFailedMessage, fileTypeErrorText, label} = props;

  return (
    <div className="drop-zone__taxonomy-import">
      <DragDropFile
        handleDrop={handleDrop}
        dragFlag={false}
        dragDropFileHandler={() => { }}
        hideDragOverlayContent
      >
        <FileUploadContainer setFile={setFile} handleDrop={handleDrop} errored={errored} importFailedMessage={importFailedMessage} fileTypeErrorText={fileTypeErrorText} label={label}/>
      </DragDropFile>
    </div>
  )
}

export default DragAndUploadFile;